<template>
  <Modal :show="visible" @close="closeDialog">
    <template #header>
      <h3 class="text-lg font-medium">编辑话题</h3>
    </template>

    <template #body>
      <div class="mt-4">
        <label
          for="topicName"
          class="block text-sm font-medium text-gray-700 dark:text-gray-300"
        >
          话题名称
        </label>
        <input
          type="text"
          id="topicName"
          v-model="topicName"
          class="mt-1 p-2 block w-full rounded-md shadow-sm border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 dark:text-gray-200 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
          placeholder="请输入话题名称"
        />
      </div>
    </template>

    <template #footer>
      <div class="flex justify-end space-x-3">
        <button
          @click="closeDialog"
          class="cancel-btn sm:text-sm"
        >
          取消
        </button>
        <LoadingBtn
          :is-loading="isLoading"
          text="保存"
          loading-text="保存中..."
          @click="handleSubmit"
          class="inline-flex w-full justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm"
        />
      </div>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import Modal from "@/components/ui/Modal.vue";
import LoadingBtn from "@/components/ui/LoadingBtn.vue";
import { updateTopicAPI } from "@/api/speaking/topic";
import toast from "@/utils/toaster";
import type { Topic } from "@/types/topic/topic";

const props = defineProps<{
  visible: boolean;
  topic: Topic | null;
}>();

const emit = defineEmits<{
  (e: "update:visible", value: boolean): void;
  (e: "topic-updated"): void;
}>();

const topicName = ref("");
const isLoading = ref(false);

watch(
  () => props.topic,
  (newTopic) => {
    if (newTopic) {
      topicName.value = newTopic.topicName;
    }
  },
  { immediate: true }
);

const closeDialog = () => {
  emit("update:visible", false);
  topicName.value = "";
};

const handleSubmit = async () => {
  if (!props.topic) return;
  if (!topicName.value.trim()) {
    toast.error("请输入话题名称");
    return;
  }

  try {
    isLoading.value = true;
    await updateTopicAPI(Number(props.topic.topicId), topicName.value.trim());
    toast.success("话题更新成功");
    emit("topic-updated");
    closeDialog();
  } catch (error: any) {
    toast.error(error.message || "更新失败");
  } finally {
    isLoading.value = false;
  }
};
</script>
